// PolicyLinks — Privacy + Terms links shown in EE page footers.
//
// Why every public EE page links these: EE landing pages run paid Meta/Google
// traffic (ad platforms require an accessible privacy policy on the destination)
// and nearly every page collects personal data (email/name) — GDPR/CCPA/CASL all
// expect the policy within easy reach. Points at the canonical TSB HubSpot pages
// (one source of truth; same URLs the SMS opt-in disclosures use).
//
// Inline by design: drop it INTO each page's existing footer rather than mounting
// a global footer — the config-driven funnel/landing pages own their own footer
// template, so a global mount would double up. Skip App.tsx + ReplayPage.

import type { CSSProperties } from 'react';

export const POLICY_LINKS = {
  privacy: 'https://www.thesuccessfulbookkeeper.com/privacy-policy',
  terms: 'https://www.thesuccessfulbookkeeper.com/terms-of-use',
} as const;

// Contact page — same canonical-source rationale as POLICY_LINKS above.
// Never a mailto: — the footer's Contact link should route through the site
// (form + routing), not open the visitor's local mail client.
export const CONTACT_URL = 'https://www.thesuccessfulbookkeeper.com/contact';

export function PolicyLinks({ color }: { color?: string }) {
  const a: CSSProperties = { color: color ?? 'inherit', textDecoration: 'underline' };
  return (
    <>
      <a href={POLICY_LINKS.privacy} target="_blank" rel="noopener noreferrer" style={a}>Privacy Policy</a>
      <span aria-hidden="true">&nbsp;&middot;&nbsp;</span>
      <a href={POLICY_LINKS.terms} target="_blank" rel="noopener noreferrer" style={a}>Terms</a>
    </>
  );
}
